goog.provide("shadow.js.shim.module$slate_history");
goog.provide("module$shadow_js_shim_module$slate_history");
shadow.js.shim.module$slate_history = shadow.js.nativeProvides["slate-history"] = shadow$bridge("slate-history");
module$shadow_js_shim_module$slate_history.default = shadow.js.shim.module$slate_history;
